// extracted by mini-css-extract-plugin
export default {"root":"ProfileIndexStats_root__cn7jQ","form":"ProfileIndexStats_form__QGRX4","json":"ProfileIndexStats_json__YFbNz"};